import { useMemo } from 'react'
import documents from '../../../api/documents/hooks'
import { DocumentParentElement } from '../../../api/documents/types'
import { getQueryData } from '../../../api/helpers'
import { CONTACT_TYPE } from '../../../common/constants'
import { documentFields } from '../../../common/forms/documents/fields'
import { EntityParams, useEntityParams } from '../../AppPermissionsSwitcher/EntityParamsContext'

interface ContactQueryItem {
    internalAppId?: string | number
    contactPerson?: { firstName?: string; lastName?: string }
    contactCompany?: { name?: string }
}

const getContactIdOptions = (
    parentId: string | number | undefined,
    contactType: string | undefined,
    parentElement: DocumentParentElement | null | undefined,
    entityParams: EntityParams | undefined
) => {
    // parentElement field available only in DocumentsList response
    if (parentElement?.element?.contactType) {
        return [{ label: parentElement?.title, value: parentElement?.element?.internalAppId?.toString() }]
    }

    if (!contactType || !parentId) return undefined

    const module = contactType === CONTACT_TYPE.PERSON ? 'contacts' : 'companies'

    const item = getQueryData<{ item?: ContactQueryItem }>([module, parentId], entityParams)?.item

    if (!item) return undefined

    switch (contactType) {
        case CONTACT_TYPE.PERSON:
            return item.contactPerson
                ? [{ value: item.internalAppId, label: `${item.contactPerson.firstName} ${item.contactPerson.lastName}` }]
                : undefined
        case CONTACT_TYPE.COMPANY:
            return item.contactCompany ? [{ value: item.internalAppId?.toString(), label: item.contactCompany.name }] : undefined
        default:
            return undefined
    }
}

export const useDocumentFormSelectOptions = (parentId?: string | number, contactType?: string, parentElement?: DocumentParentElement | null) => {
    const { data: documentValues, isPending } = documents.FormValues.useQuery(['type'])
    const entityParams = useEntityParams()
    const contactIdOptions = getContactIdOptions(parentId, contactType, parentElement, entityParams)

    const selectOptions = useMemo(
        () => ({
            [documentFields.DOCUMENT_TYPE]: documentValues?.type,
            ...(contactIdOptions ? { [documentFields.DOCUMENT_CONTACT_ID]: contactIdOptions } : {}),
        }),
        [documentValues, contactIdOptions]
    )

    return { selectOptions, isPending }
}
